module.exports = __webpack_public_path__ + "media/video_30s.9db3211f.mp4";